import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto px-8 flex flex-row md:items-center md:justify-center h-screen" }
const _hoisted_2 = { class: "w-full md:w-2/3 mx-auto flex flex-col space-y-8 mt-8 md:mt-0" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 md:gap-x-8 gap-y-4 md:gap-y-8" }
const _hoisted_4 = { class: "flex flex-col space-y-4" }

import InputText from "@/components/Form/InputText.vue";
import { ref } from "vue";
import ButtonBase from "@/components/Buttons/ButtonPrimary.vue";
import { useAuthStore } from "@/store/useAuthStore";
import TitleBig from "@/components/Titles/TitleBig.vue";
import InputColor from "@/components/Form/InputColor.vue";
import RouterLinkCustom from "@/components/Texts/RouterLinkCustom.vue";
import LabelBase from "@/components/Texts/LabelBase.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

const authStore = useAuthStore();

const nameValue = ref("");
const emailValue = ref("");
const passwordValue = ref("");
const repeatPasswordValue = ref("");
const colorValue = ref("#8b5df2");

const tryRegister = () => {
  authStore.registerUser(
    nameValue.value,
    emailValue.value,
    colorValue.value,
    passwordValue.value,
    repeatPasswordValue.value
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TitleBig, { text: "Register" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InputText, {
          name: "name",
          is_required: true,
          id: "name",
          modelValue: nameValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameValue).value = $event)),
          placeholder: "Name",
          type: "text",
          error: "name"
        }, null, 8, ["modelValue"]),
        _createVNode(InputText, {
          name: "email",
          is_required: true,
          id: "email",
          modelValue: emailValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailValue).value = $event)),
          placeholder: "Email",
          type: "email",
          error: "email"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LabelBase, { text: "Color" }),
          _createVNode(InputColor, {
            name: "color",
            placeholder: "Color",
            id: "color",
            modelValue: colorValue.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((colorValue).value = $event)),
            is_required: true
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(InputText, {
          name: "password",
          is_required: true,
          id: "password",
          modelValue: passwordValue.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((passwordValue).value = $event)),
          placeholder: "Password",
          type: "password",
          error: "password"
        }, null, 8, ["modelValue"]),
        _createVNode(InputText, {
          name: "repeatPassword",
          is_required: true,
          id: "repeat-password",
          modelValue: repeatPasswordValue.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((repeatPasswordValue).value = $event)),
          placeholder: "Repeat password",
          type: "password",
          error: "password"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(ButtonBase, {
        class: "w-1/2 md:w-1/4 m-auto md:m-0",
        text: "Sign up",
        onClick: tryRegister
      }),
      _createVNode(RouterLinkCustom, {
        to: "/login",
        text: "Already have an account ?"
      })
    ])
  ]))
}
}

})